import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, firstValueFrom, of, tap } from 'rxjs';

import { environment } from '@env';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class SignInComponent implements OnInit {
  private readonly httpClient = inject(HttpClient);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  async ngOnInit(): Promise<void> {
    const signature = this.route.snapshot.queryParamMap.get('sig');
    const expires = this.route.snapshot.queryParamMap.get('exp');
    const url = this.route.snapshot.queryParamMap.get('url');
    const claims = this.route.snapshot.queryParamMap.get('cl')!;

    if (!url) {
      this.router.navigateByUrl('/');
      return;
    }

    await firstValueFrom(
      this.httpClient
        .post<{ token: string; expires: string }>(environment.v3.apiBaseUrl + '/sign-in/v1.0/signature', {
          signature,
          expires,
          url,
          claims,
        })
        .pipe(
          tap((r) => {
            localStorage.setItem('BOABAAS_JWT', r.token);
            this.router.navigateByUrl(url);
          }),
          catchError((err: HttpErrorResponse) => {
            if (err.status === 403) {
              this.router.navigateByUrl('/');
              return of(null);
            }

            const tree = this.router.parseUrl(url);
            tree.queryParams = { ...tree.queryParams, err: err.status };
            this.router.navigateByUrl(tree);

            return of(null);
          }),
        ),
    );
  }
}
